import React from 'react'
import PropTypes from 'prop-types'
import {Text, Tag, TagLeftIcon, TagLabel} from '@chakra-ui/react'

import {InverseTickedIcon} from '../../icons'
import {toLocalDate, toEpochMillisecond} from '../../../utils/formatter'

export const BillDueDateCell = ({getValue}) => (
  <Text>{toLocalDate(toEpochMillisecond(getValue()))}</Text>
)

BillDueDateCell.propTypes = {
  getValue: PropTypes.func.isRequired,
}

export const BillStatusCell = ({getValue}) => {
  return (
    <Tag variant="status" colorScheme="info">
      <TagLeftIcon boxSize="12px" mr="1" as={InverseTickedIcon} />
      <TagLabel>{getValue()}</TagLabel>
    </Tag>
  )
}

BillStatusCell.propTypes = {
  getValue: PropTypes.func.isRequired,
}
